<div class="main">
    <div class="settings-header">
        <div class="main-title">
            <h1>SmartPoultry Info & Legal</h1>
            <p>Information about SmartPoultry and legal documents</p>
        </div>
    </div>

    <div class="settings-content">
        <!-- SmartPoultry Information Card -->
        <div class="info-card">
            <div class="card-header">
                <div class="logo-section">
                    <div class="logo-icon">
                        <img
                            src="/assets/img/logo-no-text-no-bg.png"
                            alt="smartpoultary logo"
                        />
                    </div>
                    <div class="logo-text">
                        <h2>{{ smartPoultryInfo.name }}</h2>
                        <p class="tagline">{{ smartPoultryInfo.tagline }}</p>
                    </div>
                </div>
            </div>

            <div class="card-body">
                <p class="description">{{ smartPoultryInfo.description }}</p>

                <div class="info-grid">
                    <!-- Support Email -->
                    <div class="info-item">
                        <div class="info-icon">
                            <i class="fas fa-envelope"></i>
                        </div>
                        <div class="info-content">
                            <label>Support Email</label>
                            <div class="email-actions">
                                <a
                                    [href]="
                                        'mailto:' +
                                        smartPoultryInfo.supportEmail
                                    "
                                    class="email-link"
                                >
                                    {{ smartPoultryInfo.supportEmail }}
                                </a>
                            </div>
                        </div>
                    </div>

                    <!-- Website -->
                    <div class="info-item">
                        <div class="info-icon">
                            <i class="fas fa-globe"></i>
                        </div>
                        <div class="info-content">
                            <label>Website</label>
                            <p class="info-value">
                                <a
                                    class="website-link"
                                    href="{{ smartPoultryInfo.website }}"
                                    target="_blank"
                                    >{{ smartPoultryInfo.website }}
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Legal Documents Section -->
        <div class="legal-section">
            <div class="section-header">
                <h2>Legal Documents</h2>
                <p>View and download important legal information</p>
            </div>

            <div class="documents-grid">
                <!-- Document Card for each legal document -->
                <div *ngFor="let doc of legalDocuments" class="document-card">
                    <div class="document-icon">
                        <i [class]="doc.icon"></i>
                    </div>

                    <div class="document-content">
                        <h3>{{ doc.title }}</h3>
                        <p class="document-description">
                            {{ doc.description }}
                        </p>
                    </div>

                    <div class="document-actions">
                        <button
                            type="button"
                            class="btn btn-view"
                            (click)="viewDocument(doc)"
                            title="View document"
                        >
                            <i class="fas fa-eye"></i>
                            View
                        </button>
                        <button
                            type="button"
                            class="btn btn-download"
                            (click)="downloadDocument(doc)"
                            title="Download document"
                        >
                            <i class="fas fa-download"></i>
                            Download
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
